
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 3.75C11.54 3.75 4.25 11.04 4.25 20s7.29 16.25 16.25 16.25S36.75 28.96 36.75 20 29.46 3.75 20.5 3.75zm5.884 20.366a1.25 1.25 0 01.389.89 1.25 1.25 0 01-.78 1.175 1.25 1.25 0 01-1.377-.297L20.5 21.768l-4.116 4.116a1.25 1.25 0 01-1.745-.023 1.25 1.25 0 01-.023-1.745L18.732 20l-4.116-4.116a1.25 1.25 0 011.768-1.767l4.116 4.115 4.116-4.115a1.25 1.25 0 011.745.022 1.25 1.25 0 01.023 1.745L22.268 20l4.116 4.116z","fill":"#fff"}})])
          )
        }
      }
    